import './polyfills'

import settings, { loadConfig } from 'settings'
import { ensureUnpartitionedStorageAccessIfNeeded } from 'app/ui/EmbeddedStorageAccess'
import { isInIframe, isInSandboxedIframe } from 'app/utils/embedding'
import { preloadWorkerScriptsAsBlobs } from './features/common/utils/deckGlWorkers'
import { patchRequestScheduler } from './features/builder/utils/standalone-request-scheduler-patch'
import { DESIGN_QA_SCENARIOS_ENABLED, startDesignQaScenarios } from '@cloud-native/design-qa-scenarios'

const boostrapApp = async () => {
  if (DESIGN_QA_SCENARIOS_ENABLED) {
    await startDesignQaScenarios(
      () => import('./devtools/designQa/initiatives').then(({ DESIGN_QA_INITIATIVES }) => DESIGN_QA_INITIATIVES),
      settings
    )
  }

  await loadConfig()

  const isViewer = window.location.pathname.startsWith('/viewer')
  const isOldViewerIframeAuthenticationMethod =
    isViewer && !window.location.search.includes('use-external-access-token')

  const needsUnpartitionedStorageAccess = isInIframe && isOldViewerIframeAuthenticationMethod
  if (needsUnpartitionedStorageAccess) {
    // Must run before ReactApp loads, as it swaps window.localStorage before Auth0 reads its session.
    await ensureUnpartitionedStorageAccessIfNeeded()
  }

  if (isInSandboxedIframe()) {
    await preloadWorkerScriptsAsBlobs()
  }

  // Apply RequestScheduler and Tileset2D patches before React app loads
  // TODO: Remove once loaders.gl 4.4 is released with native setProps() support
  patchRequestScheduler()

  const { renderApp } = await import('./ReactApp')
  renderApp()
}

boostrapApp()
